(()=>{
  function updateEtas(){
    const cards=document.querySelectorAll('[data-native-eta], [data-ssh-eta]');
    if(!cards.length)return;
    const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
    const today=new Date(Date.UTC(parts.year,parts.month-1,parts.day,12));
    const afterDays=count=>{const day=new Date(today);day.setUTCDate(day.getUTCDate()+count);return day};
    const formatter=new Intl.DateTimeFormat(document.documentElement.lang||'en-CA',{month:'short',day:'numeric',timeZone:'UTC'});
    cards.forEach(card=>{
      const fast=card.dataset.speed==='fast';
      const first=afterDays(fast?4:16),last=afterDays(fast?9:17);
      const year=last.getUTCFullYear()!==today.getUTCFullYear()?', '+last.getUTCFullYear():'';
      const target=card.querySelector('[data-eta-dates]');
      if(target)target.textContent=formatter.format(first)+' – '+formatter.format(last)+year;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',updateEtas,{once:true});
  else updateEtas();
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)updateEtas()});
  window.addEventListener('pageshow',updateEtas);
  setInterval(updateEtas,60000);
})();
